export const getBloodTypeOptions = (translations: (key: string) => string) => [
  { id: 'A+', label: translations('blood_type_a_positive') },
  { id: 'A-', label: translations('blood_type_a_negative') },
  { id: 'B+', label: translations('blood_type_b_positive') },
  { id: 'B-', label: translations('blood_type_b_negative') },
  { id: 'AB+', label: translations('blood_type_ab_positive') },
  { id: 'AB-', label: translations('blood_type_ab_negative') },
  { id: 'O+', label: translations('blood_type_o_positive') },
  { id: 'O-', label: translations('blood_type_o_negative') },
];

export const getRelationshipStatusOptions = (translations: (key: string) => string) => [
  { id: 'single', label: translations('relationship_status_single') },
  { id: 'married', label: translations('relationship_status_married') },
  { id: 'divorced', label: translations('relationship_status_divorced') },
  { id: 'widow', label: translations('relationship_status_widow') },
];
